import { http, HttpResponse } from 'msw'

import { connectedUser } from 'app/mocks/data/settings/auth/me'

import { api } from 'app/utils/constants'

import { KonsoleUser } from 'app/types/users/konsole'

export const getMe = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.ME}`,
    () => {
        return HttpResponse.json<KonsoleUser>(connectedUser)
    },
)
